
<div class="d-lg-none d-block bg-primary" #barcodeRef>
  <fgb-barcode></fgb-barcode>
</div>

<!-- V2 Wallet -->
<div #walletContainer class="wallet-container">
  <div class="grab-point d-lg-none">
    <span class="minimize-icon"> </span>
  </div>
  <ng-container *ngIf="walletItems$ | async as walletItems">
    <div class="wallet-redeem-carousel mt-lg-30">
      <div class="container">
        <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      </div>
    </div>
  </ng-container>

  <div class="container mt-3 text-center mb-lg-5">
    <div class="claimed-button border bg-card-fill">
      <div class="claimed-button-text">
        <h5 class="claimed-heading mb-1">{{ 'wallet.redeemed.title' | translate }}</h5>
        <div class="font-size-14 text-black">{{ 'wallet.page.claimed.rewards.subtitle' | translate }}</div>
      </div>
      <a
        class="font-size-14 claimed-text fw-bold btn btn-quaternary bg-primary rounded border-0 text-white"
        [routerLink]="['/rewards/claimed']"
      >
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
